import { routes } from '@/configs/routes';
import { UserRole } from '@/lib/types';

export { deepCopy, toUTCNoonISOString } from '@/lib/common';

export const getRestrictedRoutes = (role: UserRole) => {
  return routes.filter((route) => !route.permission.includes(role));
};
